import { HStack, Stack, Text } from '@chakra-ui/react';

import { FONTS_OPACITY } from '@/constant';

import { CloseButton } from '../../common/CloseButton';

export function DrawerTitle({
  title,
  description,
  hideCloseButton,
  onClose,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  hideCloseButton?: boolean;
  onClose?: () => void;
}) {
  return (
    <Stack gap={2} width='full'>
      <HStack
        width='full'
        gap={4}
        justifyContent='space-between'
        alignItems='flex-start'
      >
        <Text size='headingPrimary' width='full'>
          {title}
        </Text>
        {!hideCloseButton && onClose && <CloseButton onClick={onClose} />}
      </HStack>
      {description && (
        <Text opacity={FONTS_OPACITY} size='secondaryRegular'>
          {description}
        </Text>
      )}
    </Stack>
  );
}
